import { render, staticRenderFns } from "./Classes_Enrollment.vue?vue&type=template&id=1abfdcf4&scoped=true&"
import script from "./Classes_Enrollment.vue?vue&type=script&lang=js&"
export * from "./Classes_Enrollment.vue?vue&type=script&lang=js&"
import style0 from "./Classes_Enrollment.vue?vue&type=style&index=0&id=1abfdcf4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1abfdcf4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VDataTable,VRow,VSpacer,VTextField})
